import React from "react";

// Главная страница без TailwindCSS, адаптивная с чистыми стилями
export default function TarifPage() {
    return (
        <main
            style={{
                display: "flex",
                justifyContent: "center",
                overflow: "auto",
                backgroundColor: "transparent",
            }}
        >
            <section
                style={{
                    width: "100%",
                    borderRadius: "16px",
                    padding: "8px",
                    color: "black",
                    boxShadow: "0 6px 30px rgba(16,61,100,0.06)",
                    lineHeight: "1.6",
                    fontFamily: "Arial, sans-serif",
                    backgroundColor: "rgba(255,255,255,0)",
                    height: "fit-content",
                    maxWidth: "900px"
                }}
            >
                <h1
                    style={{
                        fontSize: "28px",
                        fontWeight: "600",
                        marginBottom: "10px",
                        color: "#103d64",
                    }}
                >
                    Условия доставки
                </h1>

                <hr style={{ border: "1px solid #103d64", width: "100px", marginBottom: "20px" }} />

                <div style={{ fontSize: "18px" }}>
                    <p><strong>Цена доставки за 100 грамм веса:</strong></p>
                    <ul style={{ marginLeft: "20px" }}>
                        <li>США – 90 сом,</li>
                        <li>Испания – 120 сом.</li>
                    </ul>

                    <p style={{ marginTop: "15px" }}>
                        <strong>
                            Тариф для заказов в коробках.
                        </strong>
                    </p>

                    <p style={{ margin: "10px 0" }}>
                        Стоимость доставки считается по физическому и объёмному весу.
                    </p>

                    <p style={{ margin: "10px 0", color: "#103d64", fontWeight: "bold" }}>
                        Объёмный вес = (длина × ширина × высота) / 6000
                    </p>

                    <p style={{ margin: "10px 0" }}>
                        Расчёт стоимости доставки: если объёмный вес больше физического,
                        дополнительно к тарифу по физическому весу оплачивается{" "}
                        <strong>60 сом за каждые 100 г</strong> превышения объёмного веса
                        над физическим весом.
                    </p>

                    <p style={{ marginTop: "10px" }}>
                        👉 Если объёмный вес равен или меньше физического — оплачивается
                        только физический вес.
                    </p>

                    <p>
                        Авиалинии нам выставляют по такому же принципу.
                    </p>

                    <p>
                        По многочисленным просьбам клиентов, которые не хотят переплачивать за коробку и объёмный вес,
                        мы внедрили переупаковку посылок на складах Испании и США в пакеты или пупырчатые плёнки.
                    </p>

                    <p><strong>Коробки оставляем в следующих случаях:</strong></p>
                    <ul style={{ marginLeft: "30px" }}>
                        <li>Клиент указал, что коробка нужна при создании заказа в системе.</li>
                        <li>Техника.</li>
                        <li>Хрупкий товар.</li>
                        <li>Классическая обувь на каблуках.</li>
                        <li>Люксовые бренды (одежда, обувь, сумки).</li>
                    </ul>
                </div>
            </section>
        </main>
    );
}
